module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6c77a91015d19a9378fe6f70c4cc9956.6c77a910.png";